import { api } from "./Api";

export const login = async (login?: string, password?: string) => {
    return await api.post<any, any>('/api/login', JSON.stringify({ login, password }));
}

export const changePassword = async (currentPassword: string, newPassword: string) => {
    return await api.post<any, any>('/api/changePassword', JSON.stringify({ currentPassword, newPassword }));
}
